import { Component } from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'empty',
  templateUrl: './empty.html',
})

export class EmptyPage {
  public portalUrl = `${environment.PORTAL_URL}/home`;
}
